import {RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NbLoginComponent } from '@nebular/auth';
import { ConnectComponent } from './connect/connect.component';

const laRoutes: Routes = [

      {
        path: 'test',
        component: ConnectComponent,
      },
      
];



@NgModule({
  declarations:[ ConnectComponent],
  imports: [RouterModule.forChild(laRoutes)],
  exports: [RouterModule],
})
export class HorsideRoutingModule {
}
